//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscGraph(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.5 4H10.5V20H13.5V4Z" fill="currentColor" /><path d="M7.5 12H4.5V20H7.5V12Z" fill="currentColor" /><path d="M19.5 9H16.5V20H19.5V9Z" fill="currentColor" /></svg>;
}
export default IconMiscGraph;